import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import { NumericFormat } from "react-number-format";

export default function Themtuyencodinh() {
  const [thangnam, setThangnam] = React.useState(dayjs());
  const [sotuyen_noitinh, setSotuyen_noitinh] = React.useState(0);
  const [sotuyen_lientinh, setSotuyen_lientinh] = React.useState(0);
  const [sophuongtien_noitinh, setSophuongtien_noitinh] = React.useState(0);
  const [sophuongtien_lientinh, setSophuongtien_lientinh] = React.useState(0);
  const [
    sochuyenxethuchien_noitinh,
    setSochuyenxethuchien_noitinh,
  ] = React.useState(0);
  const [
    sochuyenxethuchien_lientinh,
    setSochuyenxethuchien_lientinh,
  ] = React.useState(0);
  const [
    sochuyenxekehoach_noitinh,
    setSochuyenxekehoach_noitinh,
  ] = React.useState(0);
  const [
    sochuyenxekehoach_lientinh,
    setSochuyenxekehoach_lientinh,
  ] = React.useState(0);
  const [sokhach_noitinh, setSokhach_noitinh] = React.useState(0);
  const [sokhach_lientinh, setSokhach_lientinh] = React.useState(0);
  const [doanhthu, setDoanhthu] = React.useState(0);
  const [ghichu_baocao, setGhichu_baocao] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [disableBT, setDisableBT] = React.useState(false);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  const insertbaocao = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url = Config.backend + "/api/Phuongtien/themslthtuyencodinh_202608";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        thang: thang,
        sotuyen_noitinh: sotuyen_noitinh,
        sotuyen_lientinh: sotuyen_lientinh,
        sophuongtien_noitinh: sophuongtien_noitinh,
        sophuongtien_lientinh: sophuongtien_lientinh,
        sochuyenxethuchien_noitinh: sochuyenxethuchien_noitinh,
        sochuyenxethuchien_lientinh: sochuyenxethuchien_lientinh,
        sochuyenxekehoach_noitinh: sochuyenxekehoach_noitinh,
        sochuyenxekehoach_lientinh: sochuyenxekehoach_lientinh,
        sokhach_noitinh: sokhach_noitinh,
        sokhach_lientinh: sokhach_lientinh,
        doanhthu: doanhthu,
        ghichu_baocao: ghichu_baocao,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          showNotification();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Tháng báo cáo"
                  value={thangnam}
                  format="MM/YYYY"
                  onChange={(newValue) => {
                    setDisableBT(false);
                    setThangnam(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Ghi chú báo cáo"
                variant="outlined"
                size="small"
                value={ghichu_baocao}
                onChange={(event) => {
                  setGhichu_baocao(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Số tuyến nội tỉnh"
                variant="outlined"
                size="small"
                value={sotuyen_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyen_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <NumericFormat
                label="Số tuyến liên tỉnh"
                variant="outlined"
                size="small"
                value={sotuyen_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSotuyen_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "18px" }}>
              <NumericFormat
                label="Số phương tiện tuyến nội tỉnh"
                variant="outlined"
                size="small"
                value={sophuongtien_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSophuongtien_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "18px" }}>
              <NumericFormat
                label="Số phương tiện tuyến liên tỉnh"
                variant="outlined"
                size="small"
                value={sophuongtien_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSophuongtien_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "18px" }}>
              <NumericFormat
                label="Số chuyến xe thực hiện nội tỉnh"
                variant="outlined"
                size="small"
                value={sochuyenxethuchien_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenxethuchien_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: "18px" }}>
              <NumericFormat
                label="Số chuyến xe thực hiện liên tỉnh"
                variant="outlined"
                size="small"
                value={sochuyenxethuchien_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenxethuchien_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Số chuyến xe kế hoạch nội tỉnh"
                variant="outlined"
                size="small"
                value={sochuyenxekehoach_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenxekehoach_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Số chuyến xe kế hoạch liên tỉnh"
                variant="outlined"
                size="small"
                value={sochuyenxekehoach_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSochuyenxekehoach_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Số khách nội tỉnh"
                variant="outlined"
                size="small"
                value={sokhach_noitinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSokhach_noitinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Số khách liên tỉnh"
                variant="outlined"
                size="small"
                value={sokhach_lientinh}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setSokhach_lientinh(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <NumericFormat
                label="Doanh thu (tr.đ)"
                variant="outlined"
                size="small"
                value={doanhthu}
                customInput={TextField}
                allowNegative={false}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                onValueChange={({ value }) => {
                  setDoanhthu(value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          disabled={disableBT}
          onClick={insertbaocao}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
